import { useQuery } from '@tanstack/react-query';
import { IGetAllDrivers } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getAllDrivers = async (params: any) => {
  const res = await apiManager.get<IGetAllDrivers>("/admin/driver/all", params);
  return res;
};


export const useGetAllDrivers = (params: any) =>
  useQuery({
    queryKey: ["get_all_drivers", params],
    queryFn: async (): Promise<IGetAllDrivers> => {
      const res = await apiClient.get(ENDPOINTS.DRIVER.GET_ALL_DRIVERS, { params });
      return res.data;
    },
  });